<template>
  <div>
    <footer id="index-footer" class="footer">
      <div class="footer__inner">
       
        <div class="footer-social-icons-wrapper">
          <ul class="social-icons">
            <li class="social-icons__item">
              <a
                :href="socialData?.teligram"
                rel="nofollow"
                target="_blank"
                class="social-icons__icon is-telegram"
              ></a>
            </li>
            <li class="social-icons__item">
              <a
                :href="socialData?.twitter"
                rel="nofollow"
                target="_blank"
                class="social-icons__icon is-twitter"
              ></a>
            </li>
            <li
              class="social-icons__item"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <a
                :href="socialData?.facebook"
                rel="nofollow"
                target="_blank"
                class=" "
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: #2b2740;
                  height: 50px;
                  width: 50px;
                  border-radius: 50%;
                "
              >
                <svg viewBox="0 0 425 512" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="#FFFFFF"
                    d="M245.5 205q-3.5 0-8.5 3.25t-5 9.75v13h39.5v52H232v105h-52V283h-39.5v-52H180v-26q0-10 4.5-19.5t12.75-16.75T216.5 157t24-4.5h44V205h-39z"
                  />
                </svg>
              </a>
            </li>

            <li
              class="social-icons__item"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <a
                :href="socialData?.instagram"
                rel="nofollow"
                target="_blank"
                class=" "
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: #2b2740;
                  height: 50px;
                  width: 50px;
                  border-radius: 50%;
                "
              >
                <svg
                  fill="none"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clip-rule="evenodd"
                    d="m7.46494 1.066c1.17334-.05378 1.54734-.066 4.53506-.066 2.9883 0 3.3617.01283 4.5344.066 1.1715.05317 1.9715.23956 2.6712.5115.7339.27631 1.3987.70924 1.9482 1.26867.5595.54943.9925 1.21429 1.2687 1.94822.2719.69972.4577 1.49967.5115 2.67055.0538 1.17334.066 1.54734.066 4.53506 0 2.9877-.0128 3.3617-.066 4.5351-.0532 1.1708-.2396 1.9708-.5115 2.6705-.2811.723-.6576 1.3371-1.2687 1.9482-.5494.5595-1.2143.9925-1.9482 1.2687-.6997.2719-1.4997.4577-2.6705.5115-1.1734.0538-1.5474.066-4.5351.066-2.98772 0-3.36172-.0128-4.53506-.066-1.17088-.0532-1.97083-.2396-2.67055-.5115-.72295-.2811-1.33711-.6576-1.94822-1.2687-.55953-.5494-.99249-1.2143-1.26867-1.9482-.27194-.6997-.45772-1.4997-.5115-2.6705-.05378-1.1734-.066-1.5468-.066-4.5351 0-2.98833.01283-3.36172.066-4.53444.05317-1.1715.23956-1.97145.5115-2.67117.27631-.73388.70924-1.39871 1.26867-1.94822.54942-.55953 1.21428-.99249 1.94822-1.26867.69972-.27194 1.49967-.45772 2.67055-.5115zm8.98026 1.98c-1.1599-.05256-1.5082-.06417-4.4452-.06417s-3.28533.01161-4.44522.06417c-1.0725.04889-1.65489.22794-2.04234.37889-.51333.19922-.88.43755-1.265.82255-.38438.385-.62333.75167-.82255 1.265-.15095.38745-.33.96984-.37889 2.04234-.05256 1.15989-.06417 1.50822-.06417 4.44522s.01161 3.2853.06417 4.4452c.04889 1.0725.22794 1.6549.37889 2.0424.17622.4778.4573.91.82255 1.265.3549.3652.78717.6463 1.265.8225.38745.151.96984.33 2.04234.3789 1.15989.0526 1.50761.0642 4.44522.0642 2.9376 0 3.2853-.0116 4.4452-.0642 1.0725-.0489 1.6549-.2279 2.0424-.3789.5133-.1992.88-.4375 1.265-.8225.3652-.3549.6463-.7872.8225-1.265.151-.3875.33-.9699.3789-2.0424.0526-1.1599.0642-1.5082.0642-4.4452s-.0116-3.28533-.0642-4.44522c-.0489-1.0725-.2279-1.65489-.3789-2.04234-.1992-.51333-.4375-.88-.8225-1.265-.385-.38438-.7517-.62333-1.265-.82255-.3875-.15095-.9699-.33-2.0424-.37889zm-5.8497 12.3449c.4453.1845.9225.2794 1.4045.2794.9735 0 1.907-.3867 2.5953-1.075.6884-.6883 1.0751-1.6219 1.0751-2.5953s-.3867-1.907-1.0751-2.59532c-.6883-.68832-1.6218-1.07502-2.5953-1.07502-.482 0-.9592.09494-1.4045.27939-.4454.18445-.84997.4548-1.19079.79563-.34082.34082-.61118.74542-.79563 1.19072s-.27938.9226-.27938 1.4046.09493.9593.27938 1.4046.45481.8499.79563 1.1907.74539.6112 1.19079.7956zm-2.59345-7.38889c1.06033-1.06033 2.49845-1.65602 3.99795-1.65602 1.4996 0 2.9377.59569 3.998 1.65602s1.656 2.49849 1.656 3.99799-.5957 2.9376-1.656 3.998c-1.0603 1.0603-2.4984 1.656-3.998 1.656-1.4995 0-2.93762-.5957-3.99795-1.656-1.06033-1.0604-1.65602-2.4985-1.65602-3.998s.59569-2.93766 1.65602-3.99799zm10.90565-.81363c.2506-.25065.3914-.59059.3914-.94505 0-.35447-.1408-.69441-.3914-.94505-.2507-.25064-.5906-.39145-.9451-.39145-.3544 0-.6944.14081-.945.39145-.2507.25064-.3915.59058-.3915.94505 0 .35446.1408.6944.3915.94505.2506.25064.5906.39145.945.39145.3545 0 .6944-.14081.9451-.39145z"
                    fill="white"
                    fill-rule="evenodd"
                  />
                </svg>
              </a>
            </li>

            <li
              class="social-icons__item"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <a
                :href="socialData?.whatsapp"
                rel="nofollow"
                target="_blank"
                class=" "
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: #2b2740;
                  height: 50px;
                  width: 50px;
                  border-radius: 50%;
                "
              >
                <svg
                  height="28"
                  fill="white"
                  viewBox="0 0 512 512"
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m414.73 97.1a222.14 222.14 0 0 0 -157.79-65.1c-122.94 0-223.02 99.58-223.07 222a220.61 220.61 0 0 0 29.78 111l-31.65 115 118.25-30.87a223.63 223.63 0 0 0 106.6 27h.09c122.93 0 223-99.59 223.06-222a220.18 220.18 0 0 0 -65.27-157.03zm-157.79 341.56h-.08a185.75 185.75 0 0 1 -94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7a183.46 183.46 0 0 1 -28.35-98.17c0-101.73 83.21-184.5 185.48-184.5a185 185 0 0 1 185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 0 0 -14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0 0 31.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z"
                    fill-rule="evenodd"
                  />
                </svg>
              </a>
            </li>

            <li
              class="social-icons__item"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <a
                :href="socialData?.linkedin"
                rel="nofollow"
                target="_blank"
                class=" "
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: #2b2740;
                  height: 50px;
                  width: 50px;
                  border-radius: 50%;
                "
              >
                <svg
                  height="26"
                  fill="white"
                  viewBox="0 0 32 32"
                  width="26"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m8.268 28h-5.805v-18.694h5.805zm-2.906-21.244c-1.856 0-3.362-1.538-3.362-3.394s1.505-3.362 3.362-3.362 3.362 1.505 3.362 3.362c0 1.856-1.506 3.394-3.362 3.394zm24.632 21.244h-5.792v-9.1c0-2.169-.044-4.95-3.018-4.95-3.018 0-3.481 2.356-3.481 4.794v9.256h-5.799v-18.694h5.567v2.55h.081c.775-1.469 2.668-3.019 5.492-3.019 5.875 0 6.955 3.869 6.955 8.894v10.269z"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-images__wrap">
        <div class="footer-images">
          <div id="footer-providers-slider">
            <div
              data-v-6b9755ce=""
            
              class="bs-c-footer-swiper__wrapper"
            >
              <!-- <button
                data-v-6b9755ce=""
                class="c-button c-swiper-navigation__arrow bs-c-footer-swiper-button bs-c-footer-swiper-button-prev has-icon color-light-purple size-m"
              >
                <font-awesome-icon :icon="['fas', 'arrow-left']" size="lg" />
              </button> -->
              <div
                data-v-6b9755ce=""
                style="display:flex; gap:10px; width:100%; justify-content: center; align-items:center;"
              >
              <div
  @click="openPaymentLink(payments.link)"
  v-for="(payments, index) in payments"
  :key="index"
  data-v-6b9755ce=""
  class="payment-container"
  style="min-width: 78px; "
>
  <img
    data-v-6b9755ce=""
    :src="payments.src"
    alt="visa"
    class="payment-image"
    style="height: 50px; cursor: pointer; filter: grayscale(100%);"
  />
</div>

              </div>
              <!-- <button
                data-v-6b9755ce=""
                class="c-button c-swiper-navigation__arrow bs-c-footer-swiper-button bs-c-footer-swiper-button-next has-icon color-light-purple size-m"
              >
                <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg" />
              </button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        <div
          class="footer-copyright__top"
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 50px;
          "
        >
        <p style="text-wrap: nowrap;font-size: 16px;">{{footerText[0]}}</p>

          <ul
            class="footer-copyright__nav"
          >
            <li v-for="(menuItem, index) in menuItems" :key="index">
              <a :href="menuItem.link">
                {{ menuItem?.name }}
              </a>
            </li>
          </ul>
          <ul class="partners-div" >
            <li v-for="(partners, index) in partners" :key="index">
              <img
                @click="openPaymentLink(partners.link)"
                style="cursor: pointer; height: 50px;width:50px"
                :src="partners?.src"
              />
              
              
            </li>

                   
            
          </ul>
        </div>
        <!-- v-for="(footerText, index) in footerText"
        :key="index" -->
        <div
          style="margin-top: -40px"
          
        >
          <p _ngcontent-vxx-c156="" style="color: #969CA6;font-size: 14.3px; text-align: start">
            {{ footerText[1] }}
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "footer",
      menuItems: [],
      loading: false,
      payments: [],
      partners: [],
      socialData: {},
      footerText: [],
      SITEAUTHKEY: "",
    };
  },

  methods: {
    t(key) {
      return this.$t(key);
    },
    openPaymentLink(link) {
      if (typeof window !== "undefined") {
        window.open(link, "_blank");
      } else {
        // Handle the case where `window` is not available
        // console.error("Window object is not available");
      }
    },
    async getFooterData() {
  try {
    // Retrieve tokens from localStorage

    const response = await fetch(
      `${process.env.VUE_APP_API_KEY}/api/navigation/get-all-navigation?site_auth_key=${this.SITEAUTHKEY}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check if the request was successful
    if (!response.ok) {
      throw new Error("Failed to fetch user data");
    }

    // Parse the response JSON
    const responseData = await response.json();
    // console.log(" footer data:", responseData.data);

    // Define the required menu items
    const requiredItems = [
      "Privacy Policy",
      "Responsible Gaming",
      "Terms Conditions",
      "Complaints",
      "Cookie-policy",
    ];

    // Filter the retrieved menu items
    this.menuItems = responseData.data.filter((item) =>
      requiredItems.includes(item.name)
    );
    this.loading = false;
  } catch (error) {
    console.error("Error fetching user data:", error);
    this.loading = false;
  } finally {
    this.loading = false;
  }
},

    async getFooterPayment() {
      try {
        // Make GET request to the API endpoint
        const response = await fetch(
          `${process.env.VUE_APP_API_KEY}/api/footer-info/get-footer-info?site_auth_key=${this.SITEAUTHKEY}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        // Parse the response JSON
        const responseData = await response.json();
        // console.log("footer:", responseData.data);

        // Save the retrieved user data
        this.payments = responseData.data.payments;
        this.partners = responseData.data.partners;
        this.footerText = responseData.data.footer_text;
        // console.log(
        //   responseData.data.payments,
        //   responseData.data.partners,
        //   responseData.data.footer_text,
        //   "safafs"
        // );

        this.loading = false;
      } catch (error) {
        console.error("Error fetching user data:", error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async getSocailData() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_KEY}/api/setting/get-setting/6532c132ed5efb8183a66703?site_auth_key=${this.SITEAUTHKEY}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        // Parse the response JSON
        const responseData = await response.json();
        // console.log(" socail data:", responseData.data);

        // Save the retrieved user data
        this.socialData = responseData.data; // Corrected variable name
        // console.log( response.data,"social data")
        this.loading = false;
      } catch (error) {
        console.error("Error fetching user data:", error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    const siteAuthKey = process.env.VUE_APP_API_SITE_AUTH_KEY;
    this.SITEAUTHKEY = siteAuthKey;
    this.getFooterData();
    this.getFooterPayment();
    this.getSocailData();
  },
};
</script>

<style scoped>
.footer {
  background-color: #1b1928;
  padding: 40px 0 35px;
  position: relative;
  z-index: 1;
}

.footer__inner {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 1420px;
  gap: 0px;
  width: 100%;
  margin: auto;
}

@media (max-width: 1024px) {
  .footer__inner {
    padding: 0 15px;
  }
  .social-icons {
    display: flex;
    gap: 8px;
  }
}

.c-casino-awards--footer .c-casino-awards {
  margin: 0 0 30px;
  text-align: center;
}

.footer-social-icons-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
}

.footer-images__wrap {
  background-color: #2b2740;
}

.footer-images {
  margin: 40px auto 0;
  max-width: 1420px;
  max-width: 1330px;
  padding: 32px 40px;
  position: relative;
  text-align: center;
  width: 100%;
}
.partners-div {
    display: flex;
    gap: 2px;
    width: 20%;
    justify-content: flex-end;
}
@media (max-width: 1024px) {
  .footer-images {
    padding: 0 15px;
    padding: 32px 15px;
  }
  .partners-div {
    display: flex;
    gap: 2px;
    width: 20%;
    justify-content: center;
}
}

.footer-images a,
.footer-images span {
  display: inline-block;
  height: 24px;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.footer-images a img,
.footer-images span img {
  height: 24px;
  max-height: 24px;
  max-width: 100%;
}

.footer-images a .increase-width,
.footer-images span .increase-width {
  width: 100px;
}

.footer-images span {
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
  opacity: 0.3;
}

.footer-images span:hover {
  opacity: 0.65;
}

.is-mobile .footer,
.is-tablet .footer {
  padding: 20px 0 40px;
}

.is-mobile .footer-social-icons-wrapper,
.is-tablet .footer-social-icons-wrapper {
  margin-bottom: 20px;
}

.is-mobile .footer-social-icons-wrapper .social-icons__item,
.is-tablet .footer-social-icons-wrapper .social-icons__item {
  height: 44px;
  width: 44px;
}

.is-mobile .footer-images,
.is-tablet .footer-images {
  margin-top: 0;
  padding: 18px 0;
  width: 100%;
}

.is-mobile .c-casino-awards--footer .c-casino-awards {
  margin: 0 0 32px;
}

.is-mobile .footer__inner {
  padding: 0;
}

.bs-c-footer-swiper__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}

.footer-images span {
  height: 100%;
}

.bs-c-footer-swiper-button-prev {
  right: 50px;
}

.bs-c-footer-swiper-button-next {
  left: 50px;
}

.bs-c-swiper {
  gap: 20px;
  border:2px solid red
}

.footer-copyright {
  color: #9ea4ae;
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 1420px;
  padding: 15px 45px 50px;
  width: 100%;
}

@media (max-width: 1024px) {
  .footer-copyright {
    padding: 0 15px;
    padding-bottom: 30px;
    padding-top: 30px;
  }
}

@media (min-width: 1366px) {
  .lang-pt-BR .footer-copyright {
    font-size: 13px;
  }
}

.footer-copyright__top {
  align-items: center;
  display: flex;
  gap: 30px;
}

@media (max-width: 768px) {
  .footer-copyright__top {
    flex-direction: column-reverse;
    margin-bottom: 15px;
    text-align: center;
  }
}

.footer-copyright__text {
  margin: 0 auto 0 0;
  width: 25%;
}

@media (max-width: 768px) {
  .footer-copyright__text {
    margin: 0;
  }
}

.footer-copyright__nav {
  display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 80%;
    padding: 0px 30px;
  width: 65%;
}

@media (max-width: 1366px) {
  .footer-copyright__nav {
    display: none;
  }
}

.footer-copyright__nav a {
  color: #fff;
  cursor: pointer;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: uppercase;
}

.footer-copyright__nav a:focus,
.footer-copyright__nav a:hover {
  color: #fff;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

.lang-pt-BR .footer-copyright__nav {
  gap: 15px;
}

@media (max-width: 1520px) {
  .is-sidebar-visible .footer-copyright__nav {
    font-size: 13px;
    gap: 15px;
  }
}

.footer-copyright__icons {
  align-items: center;
  display: flex;
  gap: 18px;
  width: 20%;
}

@media (max-width: 768px) {
  .footer-copyright__icons {
    gap: 8px;
  }
}

.footer-copyright__icons li > img {
  height: 32px;
}

.footer-copyright__icons li {
  width: 25%;
}

@media (max-width: 1024px) {
  .footer-copyright__icons li > img {
    height: 24px;
  }
}

.footer-copyright__disclaimer {
  margin: 15px 0;
  text-align: left;
}

.footer-copyright__disclaimer a {
  color: #00bd71;
  cursor: pointer;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.footer-copyright__disclaimer a:focus,
.footer-copyright__disclaimer a:hover {
  color: #0dd182;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

.footer-copyright__show-more {
  align-self: center;
  color: inherit;
}
.bs-c-footer-swiper-button-prev svg {
  font-size: 3em;
}
.bs-c-footer-swiper-button-next svg {
  font-size: 3em;
}

.footer-copyright__text {
  text-align: left;
}
</style>
